<div class="question-hint base-platform-font">
  <lib-icon icon="question" [size]="16"></lib-icon>

  {{ hint }}
</div>